import React from 'react'
import Wrapper from '../components/Wrapper/Wrapper'
import { graphql } from 'gatsby'

export default function NotFoundPage({location, data}) {
	const seo = {
		siteUrl: 'https://pro.lovdata.no',
		pageUrl: '',
		siteDescription: 'Lovdata Pro er et digitalt juridisk arbeidsverktøy for advokater, dommere, jurister og andre som jobber med juss.',
		siteTitle: 'Lovdata Pro | Ikke funnet',
		image: false
	}
	return (
		<Wrapper className="ThankYouPage" seo={seo} menus={{primary: data.menuPrimary, header: data.menuHeader}} location={location}>
			<div className="ThankYou">
				<h1>Side ikke funnet</h1>
				<p><strong>Du har forsøkt å åpne en side som ikke finnes. Dette kan skyldes at siden er fjernet, flyttet eller at du har skrevet inn en feil URL.</strong></p>
				<ul>
					<li>Gå tilbake til <a className="page-link" href="/">forsiden</a></li>
					<li>Se i menyen for å navigere til andre deler av nettstedet</li>
					<li><a className="page-link" href="marked@lovdata.no">Kontakt oss</a> hvis du trenger hjelp</li>
				</ul>
			</div>
		</Wrapper>
	)
}

export const query = graphql`
	query {
		site: site {
			siteMetadata {
				description
				title
				url
			}
		}
		menuHeader: wpMenu(locations: {eq: HEADER}) {
    		count
			menuItems {
				nodes {
				id
				parentId
				label
				path
				cssClasses
				}
			}
		}
		menuPrimary: wpMenu(locations: {eq: PRIMARY}) {
			count
			menuItems {
				nodes {
				id
				parentId
				label
				path
				cssClasses
				}
			}
		}
	}
`